<template>
  <el-dialog title="文件类型设置" :visible.sync="visible" width="80%" :before-close="handleClose"
    custom-class="file-type-dialog">
    <div class="file-type-setting">
      <!-- 阶段标签页 -->
      <div class="stage-tabs">
        <el-tabs v-model="activeStage" type="card">
          <el-tab-pane v-for="step in projectFilekindList" :key="step.stepCode" :label="step.stepName"
            :name="step.stepCode">
            <!-- 新增大类按钮 -->
            <div class="add-category">
              <el-button class="btn" type="primary" size="small"
                @click="addProjectFileKind(step.stepCode)">新增大类</el-button>
            </div>

            <div style="margin-top:-7px;margin-left: -1px;">
              <!-- 文件类型表格 -->
              <el-table :data="getFlattenedRecords(activeStage)" style="width: 100%" border :height="tableHeight">
                <el-table-column prop="filekindName" label="文件大类" width="200">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isFirstRow" class="major-category">
                      {{ scope.row.filekindName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="文件小类">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isFirstRow">{{ scope.row.subclassname }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="来源" width="100" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isFirstRow">{{ getSourceText(scope.row.recordSystemFlg) }}</span>
                    <span v-else>{{ getSourceText(scope.row.systemFlg) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="canShowDelete(scope.row)" type="text" size="small"
                      @click="scope.row.isFirstRow ? deleteFileKind(scope.row) : deleteSubClass(scope.row)">
                      删除
                    </el-button>
                    <el-button v-if="scope.row.isFirstRow" type="text" size="small" @click="handleAdjust(scope.row)">
                      调整目录
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 底部按钮 - 移动到dialog内部 -->
      <div class="dialog-footer-inner">
        <el-button class="btn" type="primary" size="small" @click="handleSave">保存</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>

    </div>
    <add-fileKind v-if="addProjectFileKindVisible" ref="addFileKind"
      @refreshDataList="getProjectFileKindList()"></add-fileKind>
  </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import AddFileKind from './add-projectfilekind.vue'
export default {
  name: 'FileTypeSettingDialog',
  // props: {
  //   projectFilekindList: {
  //     type: Array,
  //     default: function () {
  //       return []
  //     }
  //   }
  // },
  data() {
    return {
      activeStage: '01', // 默认选中第一个阶段
      visible: false,
      addProjectFileKindVisible: false,
      projectFilekindList: [],
      screenHeight: 0
    }
  },
  components: {
    AddFileKind
  },
  computed: {
    // 计算表格高度
    tableHeight() {
      let height = this.screenHeight - 405;
      // 如果屏幕高度大于900，再减去20px
      if (this.screenHeight > 900) {
        height -= 30;
      }
      return height + 'px';
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight;
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    init() {
      this.visible = true
      this.activeStage = '01'
      this.getProjectFileKindList();
      console.log("this.screenHeight", this.screenHeight)
    },
    // 处理窗口大小变化
    handleResize() {
      this.screenHeight = window.innerHeight;
    },
    getProjectFileKindList() {
      this.$http({
        url: this.$store.state.httpUrl + "/business/projectfilekind/list/" + $common.getItem("workNo"),
        method: 'get',
        params: this.$http.adornParams({
        })
      }).then(({ data }) => {
        if (data && data.resultCode === 200) {
          this.projectFilekindList = data.body.records;
        }
      })
    },

    // 将记录扁平化处理，用于表格显示
    getFlattenedRecords(stepCode) {
      const step = this.projectFilekindList.find(item => item.stepCode === stepCode)
      if (!step) return []

      const flattenedRecords = []
      step.records.forEach(record => {
        // 添加大类行（第一行）
        flattenedRecords.push({
          ...record,
          isFirstRow: true,
          subclassname: '',
          systemFlg: '',
          recordSystemFlg: record.systemFlg // 保存大类的systemFlg
        })

        // 添加小类行
        if (record.subList && record.subList.length > 0) {
          record.subList.forEach(sub => {
            flattenedRecords.push({
              ...record,
              ...sub,
              isFirstRow: false,
              recordSystemFlg: record.systemFlg // 保存大类的systemFlg
            })
          })
        }
      })

      return flattenedRecords
    },

    // 获取来源文本
    getSourceText(systemFlg) {
      return systemFlg === '1' ? '系统保留' : '自定义'
    },

    // 判断是否显示删除按钮
    canShowDelete(row) {
      if (row.isFirstRow) {
        // 大类行：根据 records.systemFlg 判断
        return row.recordSystemFlg !== '1'
      } else {
        // 小类行：根据 subList.systemFlg 判断
        return row.systemFlg !== '1'
      }
    },

    // 新增大类
    addProjectFileKind(stepCode) {
      this.addProjectFileKindVisible = true
      this.$nextTick(() => {
        this.$refs.addFileKind.init(stepCode, null, 0)
      })
    },
    // 删除大类
    deleteFileKind(row) {
      const name = row.filekindName
      this.$confirm(`删除大类"${name}"时也会将大类下的小类删除，确定要删除吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$store.state.httpUrl + `/business/projectfilekind/delete`,
          method: 'post',
          data: this.$http.adornData({
            workNo: $common.getItem("workNo"),
            filekindcode: row.filekindcode
          })
        }).then(({ data }) => {
          if (data && data.resultCode === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getProjectFileKindList()
              }
            })
          }
        });
      }).catch(() => { })
    },

    // 删除小类
    deleteSubClass(row) {
      const name = row.subclassname
      this.$confirm(`确定要删除小类"${name}"吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$store.state.httpUrl + `/business/projectfilekind/deleteSubClass`,
          method: 'post',
          data: this.$http.adornData({
            workNo: $common.getItem("workNo"),
            subclasscode: row.subclasscode
          })
        }).then(({ data }) => {
          if (data && data.resultCode === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getProjectFileKindList()
              }
            })
          }
        });
      }).catch(() => { })
    },

    // 调整目录
    handleAdjust(row) {
      this.addProjectFileKindVisible = true
      this.$nextTick(() => {
        this.$refs.addFileKind.init(row.stepCode, row.filekindcode, 1)
      })
    },

    // 保存
    handleSave() {
      this.$message.success('保存成功')
      this.handleClose()
    },

    // 关闭对话框
    handleClose() {
      this.visible = false;
      this.$emit("refreshDataList");
    },
  }
}
</script>

<style scoped>
.file-type-setting {
  .stage-tabs {
    margin-bottom: 15px;
  }

  .add-category {
    margin-bottom: 10px;
  }

  .major-category {
    font-weight: bold;
    padding: 6px 0;
  }

  .dialog-footer-inner {
    text-align: center;
    padding: -10px 0 0 0;
    margin-top: 5px;
    height: 40px;
  }
}
</style>

<style>
/* 对话框样式 */
.file-type-dialog {
  height: 78%;
}

.file-type-dialog .el-dialog__body {
  height: calc(100% - 55px);
  padding: 15px 20px;
  overflow: hidden;
}

.file-type-dialog .el-table__body-wrapper {
  overflow-y: auto;
}

.file-type-dialog .el-table .el-table__row {
  height: 26px;
}

.file-type-dialog .el-table .el-table__cell {
  padding: 2px 0;
  height: 26px;
  line-height: 22px;
}

/* 确保页面不显示滚动条 */
body .v-modal {
  overflow: hidden;
}
</style>